module.exports = __webpack_public_path__ + "assets/img/Whatsapp.534ebada.svg";